// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body {
  padding: 0;
}

.u-background-black__transparent {
  background-color: rgba(0, 0, 0, 0.2);
}

.c-btn_add-operation-mode-interval {
  width: 100%;
}
@media screen and (min-width: 1069px) {
  .c-btn_add-operation-mode-interval {
    width: auto;
    float: right;
  }
}

.object-table_line {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 1.2rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
